export default __webpack_public_path__ + "static/media/about.a3175277.png";